import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import MainWalletSettingForm from '../MainWalletSettingForm'
import MainWalletProviderVersionSettings from '../MainWalletProviderVersionSettings'
import { GetMainWalletSettingResponse } from '@/modules/client-setting/type'

interface MainWalletSettingListingProps {
	data: GetMainWalletSettingResponse
}

export default function MainWalletSettingListing({
	data,
}: MainWalletSettingListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="ตั้งค่าฝากไม่รับโปร"
					description="จัดการเงื่อนไขและการตั้งค่าสำหรับกระเป๋าของผู้เล่นที่ฝากไม่รับโปร"
				/>
			</div>
			<Separator />
			<MainWalletProviderVersionSettings />
			<MainWalletSettingForm data={data} />
		</div>
	)
}
